<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout row :class="ui.textSubheading">
          <div class="ml-4 mt-4 mb-2">
            Maintenance Strategy Activity
          </div>
          <v-spacer/>
          <div class="ml-4 mr-4 mt-4">
            {{displayDocumentIDGTypeA(selectedMaintActivity.basic.tag, selectedMaintActivity.basic.idg)}}
          </div>
        </v-layout>
        <v-layout row class="ml-2 ml-2 mr-2">
          <v-flex xs8>
            <v-text-field
            v-model="selectedMaintActivity.basic.title"
            hint="actvity name"
            prepend-icon="title"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
            v-model="selectedMaintActivity.char.type"
            hint="type"
            prepend-icon="grid_view"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="ml-2 mr-2">
          <v-flex xs5>
            <v-text-field
            v-model="selectedMaintActivity.basic.id"
            hint="part id"
            prepend-icon="fingerprint"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs5>
            <v-text-field
            v-model="selectedMaintActivity.char.dis"
            hint="discipline"
            prepend-icon="engineering"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs2>
            <v-text-field
            v-model="selectedMaintActivity.char.owner"
            hint="owner"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="ml-2 mr-2">
          <v-flex xs6>
            <v-text-field
            v-model="selectedMaintActivity.char.method"
            hint="model"
            prepend-icon="model_training"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            v-model="selectedMaintActivity.char.model"
            prepend-icon="adjust"
            hint="method"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="ml-2 mr-2">
          <v-flex xs3>
            <v-text-field
            v-model="selectedMaintActivity.char.freq"
            prepend-icon="manage_history"
            persistent-hint
            hint="freq"
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs3>
            <v-text-field
            v-model="selectedMaintActivity.char.unit"
            prepend-icon="event"
            persistent-hint
            hint="unit"
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs6>
            <v-text-field
            v-model="selectedMaintActivity.char.cond"
            prepend-icon="build_circle"
            hint="condition"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="ml-2 mr-2">
          <v-flex xs4>
            <v-text-field
            v-model="selectedMaintActivity.char.imp"
            prepend-icon="group_add"
            hint="resource"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
            v-model="selectedMaintActivity.char.coste"
            prepend-icon="paid"
            hint="cost"
            prefix="$"
            :suffix="selectedMaintActivity.char.costu"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
          <v-flex xs4>
            <v-text-field
            v-model="selectedMaintActivity.char.carbe"
            prepend-icon="co2"
            :suffix="selectedMaintActivity.char.carbu"
            hint="carbon"
            persistent-hint
            readonly
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import displayFunctions from "@/data/functions/mixins/displayFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
// import AppendReadCard from "@/data/append/components/AppendReadCard";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  beforeMount() {
    // fix orginal data before change
  },
  mixins: [apptheme, displayFunctions],
  components: {
    // AppendReadCard
  },
  computed: {
    ...mapGetters(["getDetail", "getDetailChar"]),
    selectedMaintActivity() {
      return this.getDetail.strategy;
    }
  }
};
</script>
